export const findRegionByAlias = (data, alias) => {
  for (const region of data) {
    if (region?.regionName?.toUpperCase() === alias?.toUpperCase()) {
      return region;
    }
  }
  return null;
};
